<template>
  <div
    class="form-detail"
    v-if="
      (['COMPANY', 'HOUSEHOLD', 'INDIVIDUAL'].includes(dataContract.typeCustomer) &&
        customerInfo.enableSendMonthlyReport) ||
      isView
    "
  >
    <h1>Thông tin nhận hoá đơn</h1>
    <div class="form-group form-row">
      <label class="col-sm-4 col-form-label">
        Tên công ty <span class="float-right">:</span>
      </label>
      <div class="col-sm-8">
        <p class="form-control-plaintext f12" v-if="isView">
          {{ dataAppendix?.appendixNganluongConvert?.invoiceMcName }}
        </p>
        <p v-else class="form-control-plaintext f12">
          {{ customerInfo.invoiceMcName }}
        </p>
      </div>
    </div>
    <div class="form-group form-row">
      <label class="col-sm-4 col-form-label"> Địa chỉ <span class="float-right">:</span> </label>
      <div class="col-sm-8">
        <p class="form-control-plaintext f12" v-if="isView">
          {{ dataAppendix?.appendixNganluongConvert?.invoiceMcAddress }}
        </p>
        <p v-else class="form-control-plaintext f12">
          {{ customerInfo.invoiceMcAddress }}
        </p>
      </div>
    </div>
    <div class="form-group form-row">
      <label class="col-sm-4 col-form-label"> Mã số thuế <span class="float-right">:</span> </label>
      <div class="col-sm-8">
        <p class="form-control-plaintext f12" v-if="isView">
          {{ dataAppendix?.appendixNganluongConvert?.invoiceMcBusinessNumber }}
        </p>
        <p v-else class="form-control-plaintext f12">
          {{ customerInfo.invoiceMcBusinessNumber }}
        </p>
      </div>
    </div>
    <div class="form-group form-row">
      <label class="col-sm-4 col-form-label"> Họ và tên <span class="float-right">:</span> </label>
      <div class="col-sm-8">
        <p class="form-control-plaintext f12" v-if="isView">
          {{ dataAppendix?.appendixNganluongConvert?.invoiceMcContactName }}
        </p>
        <p v-else class="form-control-plaintext f12">
          {{ customerInfo.invoiceMcContactName }}
        </p>
      </div>
    </div>
    <div class="form-group form-row">
      <label class="col-sm-4 col-form-label"> Chức vụ <span class="float-right">:</span> </label>
      <div class="col-sm-8">
        <p class="form-control-plaintext f12" v-if="isView">
          {{ dataAppendix?.appendixNganluongConvert?.invoiceMcContactPosition }}
        </p>
        <p v-else class="form-control-plaintext f12">
          {{ customerInfo.invoiceMcContactPosition }}
        </p>
      </div>
    </div>
    <div class="form-group form-row">
      <label class="col-sm-4 col-form-label"> Email <span class="float-right">:</span> </label>
      <div class="col-sm-8">
        <p class="form-control-plaintext f12" v-if="isView">
          {{ dataAppendix?.appendixNganluongConvert?.invoiceMcEmail }}
        </p>
        <p v-else class="form-control-plaintext f12">
          {{ customerInfo.invoiceMcEmail }}
        </p>
      </div>
    </div>
    <div class="form-group form-row">
      <label class="col-sm-4 col-form-label">
        Số điện thoại <span class="float-right">:</span>
      </label>
      <div class="col-sm-8">
        <p class="form-control-plaintext f12" v-if="isView">
          {{ dataAppendix?.appendixNganluongConvert?.invoiceMcMobile }}
        </p>
        <p v-else class="form-control-plaintext f12">
          {{ customerInfo.invoiceMcMobile }}
        </p>
      </div>
    </div>
    <div class="form-group form-row">
      <label class="col-sm-4 col-form-label">
        Thông tin khác <span class="float-right">:</span>
      </label>
      <div class="col-sm-8">
        <p class="form-control-plaintext f12" v-if="isView">
          {{ dataAppendix?.appendixNganluongConvert?.invoiceMcOtherContact }}
        </p>
        <p v-else class="form-control-plaintext f12">
          {{ customerInfo.invoiceMcOtherContact }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['dataContract', 'dataAppendix', 'isView'],
    data() {
      return {}
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
    },
  }
</script>
<style scoped src="@/assets/css/style-review.css"></style>
